// imports
import Link from "next/link";

// lib files
import { SearchWebResultType } from "@/lib/types/search/results";
import { PromotedResultType } from "@/lib/content-services/search/promotedResults";

// components
import ITSImage from "@/components/ITSImage/ITSImage";

// svg's
import CompassRoseCorner from '@/public/svg/compass-rose-corner.svg';

// styles
import styles from './SearchWebPromotedThumbnail.module.scss';

interface SearchWebPromotedThumbnailProps {
  data: SearchWebResultType | PromotedResultType;
}

export default function SearchWebPromotedThumbnail(props: SearchWebPromotedThumbnailProps) {
  const { data } = props;
  const {
    title,
    external_url,
    image_url
  } = data;

  const normalizedTitle = title?.toLowerCase().trim();
  const isPassportWebResult = normalizedTitle?.includes("passport");

  const description =
    Object.hasOwn(data, "description_short")
      ? (data as SearchWebResultType).description_short
      : (data as PromotedResultType).description;

  // default for images for web results - if they are not ITS images
  let linkWithImageStyle: React.CSSProperties = {backgroundColor: `#fff`, padding: `12px`};

  // if they *are* ITS images, we add the image itself as a blurred background
  if (image_url?.includes('image.pbs.org')) {
    linkWithImageStyle = {backgroundImage: `url(${`${image_url}?blur=20`})`}
  }

  // special case for PBS KIDS - adding a yellow background from their style guide
  // https://pbs-kids-brand.pbskids.org/downloads/pbs-kids-style-guide.pdf
  if (normalizedTitle === "pbs kids") {
    linkWithImageStyle = {backgroundColor: `#F7E03B`, padding: `12px`};
  }

  return (
    <div className={styles.search_web_promoted_thumbnail__container}>
      <div className={styles.search_web_promoted_thumbnail}>
        <Link
          href={external_url}
          style={image_url ? linkWithImageStyle : {}}
          className={styles.search_web_promoted_thumbnail__link}
        >
          { image_url &&
            <ITSImage
              src={image_url}
              alt=''
              width={500}
              className={styles.search_web_promoted_thumbnail__image}
            />
          }
          { isPassportWebResult && (
            <span className={styles.search_web_promoted_thumbnail__compass_rose}>
              <CompassRoseCorner />
            </span>
          )}
          { !image_url && <div className={styles.search_web_promoted_thumbnail__title}>{title}</div>}
        </Link>
        <p className={styles.search_web_promoted_thumbnail__description}>
          {description}
        </p>
      </div>
    </div>
  )
}
